import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=dc4b84ec"
import script from "./train.ts?vue&type=script&lang=js&external"
export * from "./train.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports